module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "svg-sprite-0a04d67e7be2467ff8c30ec762f261a0.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }